
import api from '~/api/' // server

export default {
    name: 'DetailListUnderView',
    props: {
        params: {
            type: Object,
            default() {
                return {}
            },
        },
        subtitleName: {
            type: String,
            default: '제목',
        },
        subcontentName: {
            type: String,
            default: '내용',
        },
    },
    data() {
        return {
            detail: '',
        }
    },
    watch: {
        params() {
            this.getBoardNoticeDetail()
        },
    },
    created() {
        this.getBoardNoticeDetail()
    },
    methods: {
        async getBoardNoticeDetail() {
            const params = {
                ...this.params,
            }

            const { data } = await api.getNoticeBoardDetail(params)
            this.detail = data

            this.detail.content = this.detail.content
                        .replaceAll('\n', '<br>')
                        .replaceAll('<br><br>', '<br>')
            
            console.log('data=', data)
        },
        onClickBackToList() {
            this.$emit('backToList')
        },
    },
}
